import React, { useState, useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/ca/app/litrlly-kids/id6759176127';
const BANNER_DISMISSED_KEY = 'ios_app_banner_dismissed_v2';

const IOSAppBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if banner was previously dismissed
    const wasDismissed = localStorage.getItem(BANNER_DISMISSED_KEY);

    // Check if running as standalone (already installed as PWA)
    const isStandalone = (window.navigator as any).standalone === true;

    // Show banner for all users, unless dismissed or standalone
    if (!wasDismissed && !isStandalone) {
      // Small delay to not interfere with page load
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up safe-area-bottom">
      {/* iOS-style Smart App Banner */}
      <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border-t border-gray-200/50 dark:border-slate-700/50 px-4 py-3">
        <div className="max-w-lg mx-auto flex items-center gap-3">
          {/* Close button - iOS style */}
          <button
            onClick={handleDismiss}
            className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 p-1 -ml-1 flex-shrink-0"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* App icon - iOS rounded rect style */}
          <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-[12px] flex items-center justify-center flex-shrink-0 shadow-sm">
            <span className="text-2xl">🐳</span>
          </div>

          {/* App info */}
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 dark:text-white text-[15px] leading-tight">Litrlly Kids</p>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 leading-tight">Learn English the Fun Way</p>
            {/* App Store style - FREE label */}
            <p className="text-[11px] text-gray-400 dark:text-gray-500 leading-tight mt-0.5">FREE - App Store</p>
          </div>

          {/* GET button - iOS App Store style */}
          <a
            href={APP_STORE_URL}
            className="bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white px-5 py-1.5 rounded-full text-[15px] font-semibold transition-colors flex-shrink-0 shadow-sm"
          >
            GET
          </a>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .safe-area-bottom {
          padding-bottom: env(safe-area-inset-bottom, 0);
        }
      `}</style>
    </div>
  );
};

export default IOSAppBanner;
